export default {
  'menu.ArticleShowPage': '文章内容',
}
